// Telegram channels the news feed is built from, by interface language.
export const NEWS_CHANNEL_IDS = Object.freeze({
    ru: [2020833003, 1539211564, 1444152677, 1562118593, 2146663631, 1754931648, 2662123418],
    en: [1497424960, 1729567684, 1191264954, 1556132596, 2143019393, 1449554469],
});
